export class LoginResult {
  public sucesso: boolean;
  public erros: Array<any>;
  public warnings: Array<any>;
  public token: string;
}
